import WsService from "../WsService";
import AgentCategory from "../../domain/AgentCategory";

export default class AgentCategoryService {

    static retrieveAllAgentCategories() {

        let endpoint = "/admin/agent-category";

        return WsService.get(endpoint, {}, 200).then(
            response => {
                let responseArr = [];
                response.forEach(agentCategory => {
                    responseArr.push(new AgentCategory(agentCategory))
                });
                return responseArr;
            },
            response => {
                return response;
            }
        )
    }
}